/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';
import { mixin as clickaway } from 'vue-clickaway';

// Components
import CancelMeetingButton from 'ui/components/meetings/CancelMeetingButton.vue';
import MeetingPerson from 'ui/components/meetings/MeetingPerson.vue';
import ModalForm from 'shared/ui/components/form-components/ModalForm.vue';

const __vue_script__ = {
    name: 'MeetingDetailsPopover',

    components: {
        CancelMeetingButton,
        MeetingPerson
    },

    mixins: [clickaway],

    props: {
        container: {
            type: String,
            default: 'body'
        },

        event: {
            type: Object,
            required: true
        },

        meeting: {
            type: Object,
            default: null
        },

        virtualElement: {
            type: HTMLElement,
            default: null
        },

        module: {
            type: Object,
            required: true
        },

        onUpdated: {
            type: Function,
            default: () => {}
        },

        onDeleted: {
            type: Function,
            default: () => {}
        },

        onError: {
            type: Function,
            default: () => {}
        },

        onClose: {
            type: Function,
            default: () => {}
        },

        actions: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            open: false,
            room: this.meeting.room,
            inFront: true
        };
    },

    computed: {
        date() {
            return this.$utils.time.tsToLongDateTimeFormat(this.meeting.start, this.event.timezone);
        }
    },

    async mounted() {
        this.$refs.popover.$refs.trigger = this.virtualElement;
        this.open = Boolean(this.meeting);
    },

    methods: {
        /**
         * Returns the meeting link based on the current module's view route.
         * If the route is not available, it returns '#'.
         *
         * @returns {string} The meeting link.
         */
        getMeetingHref() {
            return this.$utils.modules.getRouteHref(this.module, 'view', { eventId: this.event._id, _id: this.meeting._id });
        },

        /**
         * Returns the location href for the current meeting.
         * @returns {string} The location href with placeholders replaced.
         */
        getLocationHref() {
            if (!this.room) {
                return null;
            }

            return this.$utils.modules.getRouteHref(this.module, 'view-location', { eventId: this.event._id, _id: this.room.id });
        },

        onBeforeCancellationPrompt() {
            this.inFront = false;
        },

        onDismissCancellationPrompt() {
            this.inFront = true;
        },

        /**
         * Opens the new meeting form modal
         */
        async openMeetingEditor() {
            this.inFront = false;

            const controller = this.$services.blueprint.getModuleByName('meetings').controllers.view;
            const { appscriptUrl } = get(controller, 'resolvers.crudItems.options');
            const doc = await this.$services.appScripts.callAppScript(this.event._id, appscriptUrl, { id: this.meeting._id });

            const meeting = Object.assign({}, this.meeting, doc);
            this.$modal.show(ModalForm, {
                title: this.$t('meetings.details.actions.edit_meeting'),
                event: this.event,
                model: meeting,
                fpType: 'meeting',
                onSave: () => this.onUpdated(),
                onClose: this.close,
                onError: () => this.onError()
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        /**
         * Closes the popover.
         *
         * The reason of closing could be multiple, such as:
         * - 'popover-close' - The user clicked the close button.
         * - 'editor-saved' - The editor saved the model.
         * - 'editor-abort' - The editor was cloesd in creation mode.
         * - 'editor-cancel' - The editor was closed in editing mode.
         *
         * @param {string} reason - The reason for closing the popover.
         * @param {object} model - The model associated with the popover.
         */
        close(reason, model) {
            this.onClose(reason, model);
            this.$emit('close');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{ref:"popover",attrs:{"trigger":"manual","auto-hide":false,"popover-class":['meeting-details-popover', _vm.meeting.status],"popover-wrapper-class":_vm.inFront ? 'wrapper' : 'hidden',"container":_vm.container,"open":_vm.open},on:{"apply-hide":function($event){return _vm.close('popover-close')}},scopedSlots:_vm._u([(_vm.meeting)?{key:"popover",fn:function(ref){return [_c('header',[_c('a',{staticClass:"close",on:{"click":function($event){return _vm.close('popover-close')}}},[_c('i',{staticClass:"ic-x"})]),_c('h2',[_vm._v(_vm._s(_vm.meeting.name))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.date))])]),_c('section',{staticClass:"organizers"},[_c('h4',[_vm._v(_vm._s(_vm.$t('meetings.details.organizer')))]),_c('meeting-person',{attrs:{"person":_vm.meeting.organizer,"acceptance":_vm.meeting.acceptance[_vm.meeting.organizer._id]}})],1),_c('section',{staticClass:"participants"},[_c('h4',[_vm._v(_vm._s(_vm.$tc('meetings.details.participants', _vm.meeting.participants.length)))]),_vm._l((_vm.meeting.participants),function(participant){return _c('meeting-person',{key:participant._id,attrs:{"person":participant,"acceptance":_vm.meeting.acceptance[participant._id]}})}),_vm._l((_vm.meeting.externals),function(guest){return _c('div',{staticClass:"meeting-person"},[_c('div',{staticClass:"details"},[_c('div',{staticClass:"name"},[_c('a',{attrs:{"href":"mailto:undefined","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(guest))])])])])})],2),_c('section',{staticClass:"location"},[_c('h4',[_vm._v(_vm._s(_vm.$t('meetings.details.location')))]),_c('p',[(_vm.getLocationHref())?[_c('a',{attrs:{"href":_vm.getLocationHref(),"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.room.title))])]:[_vm._v(_vm._s(_vm.meeting.location))]],2)]),(_vm.meeting.description)?_c('section',{staticClass:"description"},[_c('h4',[_vm._v(_vm._s(_vm.$t('meetings.details.description')))]),_c('p',[_vm._v(_vm._s(_vm.meeting.description))])]):_vm._e(),_c('footer',[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.openMeetingEditor()}}},[_vm._v(_vm._s(_vm.$t('general.edit')))]),(_vm.actions.cancel)?_c('cancel-meeting-button',{attrs:{"event":_vm.event,"action":_vm.actions.cancel,"context":_vm.meeting},on:{"change":_vm.onDeleted,"before-cancellation-prompt":_vm.onBeforeCancellationPrompt,"dismiss-cancellation-prompt":_vm.onDismissCancellationPrompt}}):_vm._e()],1)]}}:null],null,true)})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MeetingDetailsPopover.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__